import React, { useState } from "react"
import { Maximize, Minimize } from "lucide-react"

declare global {
  interface Document {
    mozFullScreenElement: Element | null
    webkitFullscreenElement: Element | null
    mozCancelFullScreen: () => void
    webkitCancelFullScreen: () => void
    msFullscreenElement: Element | null
    msRequestFullscreen: () => void
    msCancelFullScreen: () => void
    webkitIsFullScreen: boolean
    mozFullScreen: boolean
    fullscreenElement: Element | null // Standard property
    cancelFullScreen: () => void // Legacy property
  }

  interface HTMLElement {
    mozRequestFullScreen: () => void
    webkitRequestFullscreen: () => void
  }
}

const FullScreenDropdown: React.FC = () => {
  const [isFullScreenMode, setIsFullScreenMode] = useState<boolean>(true)

  const toggleFullscreen = (): void => {
    const document = window.document
    document.body.classList.add("fullscreen-enable")

    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      setIsFullScreenMode(false)
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen()
      }
    } else {
      setIsFullScreenMode(true)
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }

    const exitHandler = (): void => {
      if (
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      )
        document.body.classList.remove("fullscreen-enable")
    }

    document.addEventListener("fullscreenchange", exitHandler)
    document.addEventListener("webkitfullscreenchange", exitHandler)
    document.addEventListener("mozfullscreenchange", exitHandler)
  }

  return (
    <React.Fragment>
      <div className="ms-1 header-item d-none d-sm-flex">
        <button
          onClick={toggleFullscreen}
          type="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          {isFullScreenMode ? <Maximize size={22} /> : <Minimize size={22} />}
        </button>
      </div>
    </React.Fragment>
  )
}

export default FullScreenDropdown
